/**
 * Created by ren on 14/07/2017.
 */
export const EMPLOYEE = "dt:entity_type:employee";
export const CUSTOMER = "dt:entity_type:customer";
export const SUPPLIER = "dt:entity_type:supplier";
export const CONTACT = "dt:entity_type:contact";
export const INTEGRATION = "dt:entity_type:integration";